// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._filterModelsCollapse_x97vv_1 {
  --perxis-auto-collapse-padding: var(--perxis-auto-gap-vertical-sky-inner) 0;
  --perxis-auto-collapse-panel-padding: var(--perxis-auto-gap-vertical-sky-inner) 0;
}
._filterModelsCollapse__brandHeader_x97vv_5 {
  display: flex;
  align-items: center;
  gap: var(--perxis-auto-gap-vertical-purple-inner) 24px;
}
._filterModelsCollapse__brandHeader_x97vv_5 img {
  max-height: 40px;
  max-width: 50%;
}
._filterModelsCollapse__brandTitle_x97vv_14 {
  /* Typography */
  --pa-filter-item-model-brand-title-font-family-inner: var(
    --pa-filter-item-model-brand-title-font-family,
    var(--perxis-auto-root-typography-h5-font-family-inner)
  );
  --pa-filter-item-model-brand-title-font-size-xxs-sm-inner: var(
    --pa-filter-item-model-brand-title-font-size-xxs-sm,
    var(--perxis-auto-root-typography-h5-font-size-xxl-inner)
  );
  --pa-filter-item-model-brand-title-font-size-md-xxl-inner: var(
    --pa-filter-item-model-brand-title-font-size-md-xxl,
    var(--perxis-auto-root-typography-h5-font-size-xxl-inner)
  );
  --pa-filter-item-model-brand-title-line-height-inner: var(
    --pa-filter-item-model-brand-title-line-height,
    var(--perxis-auto-root-typography-h5-line-height-xxl-inner)
  );
  --pa-filter-item-model-brand-title-font-weight-inner: var(
    --pa-filter-item-model-brand-title-font-weight,
    var(--perxis-auto-root-typography-h5-font-weight-inner)
  );
  --pa-filter-item-model-brand-title-letter-spacing-inner: var(
    --pa-filter-item-model-brand-title-letter-spacing,
    var(--perxis-auto-root-typography-h5-letter-spacing-inner)
  );
  --pa-filter-item-model-brand-title-text-transform-inner: var(
    --pa-filter-item-model-brand-title-text-transform,
    var(--perxis-auto-root-typography-h5-text-transform-inner)
  );
  --pa-filter-item-model-brand-title-color-inner: var(
    --pa-filter-item-model-brand-title-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  --perxis-auto-typography-h5-font-family: var(--pa-filter-item-model-brand-title-font-family-inner);
  --perxis-auto-typography-h5-font-weight: var(--pa-filter-item-model-brand-title-font-weight-inner);
  --perxis-auto-typography-h5-letter-spacing: var(--pa-filter-item-model-brand-title-letter-spacing-inner);
  --perxis-auto-typography-h5-text-transform: var(--pa-filter-item-model-brand-title-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--pa-filter-item-model-brand-title-color-inner);
  --perxis-auto-typography-h5-font-size-xxs: var(--pa-filter-item-model-brand-title-font-size-xxs-sm-inner);
  --perxis-auto-typography-h5-font-size-xs: var(--pa-filter-item-model-brand-title-font-size-xxs-sm-inner);
  --perxis-auto-typography-h5-font-size-sm: var(--pa-filter-item-model-brand-title-font-size-xxs-sm-inner);
  --perxis-auto-typography-h5-font-size-md: var(--pa-filter-item-model-brand-title-font-size-md-xxl-inner);
  --perxis-auto-typography-h5-font-size-lg: var(--pa-filter-item-model-brand-title-font-size-md-xxl-inner);
  --perxis-auto-typography-h5-font-size-xl: var(--pa-filter-item-model-brand-title-font-size-md-xxl-inner);
  --perxis-auto-typography-h5-font-size-xxl: var(--pa-filter-item-model-brand-title-font-size-md-xxl-inner);
  --perxis-auto-typography-h5-line-height-xxs: var(--pa-filter-item-model-brand-title-line-height-inner);
  --perxis-auto-typography-h5-line-height-xs: var(--pa-filter-item-model-brand-title-line-height-inner);
  --perxis-auto-typography-h5-line-height-sm: var(--pa-filter-item-model-brand-title-line-height-inner);
  --perxis-auto-typography-h5-line-height-md: var(--pa-filter-item-model-brand-title-line-height-inner);
  --perxis-auto-typography-h5-line-height-lg: var(--pa-filter-item-model-brand-title-line-height-inner);
  --perxis-auto-typography-h5-line-height-xl: var(--pa-filter-item-model-brand-title-line-height-inner);
  --perxis-auto-typography-h5-line-height-xxl: var(--pa-filter-item-model-brand-title-line-height-inner);
}
._filterModelsCollapse__brandDescription_x97vv_69 {
  /* Typography */
  --pa-filter-item-model-brand-description-font-family-inner: var(
    --pa-filter-item-model-brand-description-font-family,
    var(--perxis-auto-root-typography-super-small-font-family-inner)
  );
  --pa-filter-item-model-brand-description-font-size-xxs-sm-inner: var(
    --pa-filter-item-model-brand-description-font-size-xxs-sm,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --pa-filter-item-model-brand-description-font-size-md-xxl-inner: var(
    --pa-filter-item-model-brand-description-font-size-md-xxl,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --pa-filter-item-model-brand-description-font-weight-inner: var(
    --pa-filter-item-model-brand-description-font-weight,
    var(--perxis-auto-root-typography-super-small-font-weight-inner)
  );
  --pa-filter-item-model-brand-description-letter-spacing-inner: var(
    --pa-filter-item-model-brand-description-letter-spacing,
    var(--perxis-auto-root-typography-super-small-letter-spacing-inner)
  );
  --pa-filter-item-model-brand-description-text-transform-inner: var(
    --pa-filter-item-model-brand-description-text-transform,
    var(--perxis-auto-root-typography-super-small-text-transform-inner)
  );
  --pa-filter-item-model-brand-description-color-inner: var(
    --pa-filter-item-model-brand-description-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  /* End Typography */
  margin-top: var(--perxis-auto-gap-vertical-purple-inner);
  --perxis-auto-typography-super-small-font-family: var(--pa-filter-item-model-brand-description-font-family-inner);
  --perxis-auto-typography-super-small-font-weight: var(--pa-filter-item-model-brand-description-font-weight-inner);
  --perxis-auto-typography-super-small-letter-spacing: var(
    --pa-filter-item-model-brand-description-letter-spacing-inner
  );
  --perxis-auto-typography-super-small-text-transform: var(
    --pa-filter-item-model-brand-description-text-transform-inner
  );
  --perxis-auto-typography-color-dark-light: var(--pa-filter-item-model-brand-description-color-inner);
  --perxis-auto-typography-super-small-font-size-xxs: var(--pa-filter-item-model-brand-description-font-size-xxs-sm-inner);
  --perxis-auto-typography-super-small-font-size-xs: var(--pa-filter-item-model-brand-description-font-size-xxs-sm-inner);
  --perxis-auto-typography-super-small-font-size-sm: var(--pa-filter-item-model-brand-description-font-size-xxs-sm-inner);
  --perxis-auto-typography-super-small-font-size-md: var(--pa-filter-item-model-brand-description-font-size-md-xxl-inner);
  --perxis-auto-typography-super-small-font-size-lg: var(--pa-filter-item-model-brand-description-font-size-md-xxl-inner);
  --perxis-auto-typography-super-small-font-size-xl: var(--pa-filter-item-model-brand-description-font-size-md-xxl-inner);
  --perxis-auto-typography-super-small-font-size-xxl: var(--pa-filter-item-model-brand-description-font-size-md-xxl-inner);
  --perxis-auto-typography-super-small-line-height-xxs: var(--pa-filter-item-model-brand-description-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xs: var(--pa-filter-item-model-brand-description-line-height-inner);
  --perxis-auto-typography-super-small-line-height-sm: var(--pa-filter-item-model-brand-description-line-height-inner);
  --perxis-auto-typography-super-small-line-height-md: var(--pa-filter-item-model-brand-description-line-height-inner);
  --perxis-auto-typography-super-small-line-height-lg: var(--pa-filter-item-model-brand-description-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xl: var(--pa-filter-item-model-brand-description-line-height-inner);
  --perxis-auto-typography-super-small-line-height-xxl: var(--pa-filter-item-model-brand-description-line-height-inner);
}
._filterModelsCollapse_x97vv_1 .ant-5_24_1-collapse > .ant-5_24_1-collapse-item:last-child {
  border-bottom: 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
